import { render, staticRenderFns } from "./Anticoagulants.vue?vue&type=template&id=3a111a8f&"
import script from "./Anticoagulants.vue?vue&type=script&lang=js&"
export * from "./Anticoagulants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports